module.exports = __webpack_public_path__ + "img/baekiljang.3fecd4c.jpeg";